<template>
	<div class="article-edit-container">
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<div>
				<div class="breadcrumb ant-breadcrumb"><span class="" style="font-size: 18px;"><span
							class="ant-breadcrumb-link"> {{task_type?"编辑任务":"新增任务"}} </span><span
							class="ant-breadcrumb-separator">|</span></span><span class=""
						style="font-size: 14px;"><span class="ant-breadcrumb-link"><a href="#/taskList" class=""> 任务列表
							</a> &gt; </span><span class="ant-breadcrumb-separator">|</span></span></div>
			</div>
			<div>
				<a-select placeholder="请选择合作企业" :disabled="task_type" v-model="company_id"
					style="width: 225px; margin:19px 23px 0;float:right;border-radius: 15px;"
					@change="value => onChangecompany(value)">
					<a-select-option v-for="item in companyData" :key="item.id" :value="item.id">
						{{ item.companyInfo.qichacha_name }}
					</a-select-option>
				</a-select>
			</div>
		</div>
		<div class="global-table-container">
			<div style="padding: 0 200px;">
				<el-steps :active="active" align-center>
					<el-step title="计划基础信息"></el-step>
					<el-step title="分配推广人任务"></el-step>
				</el-steps>
			</div>
			<div v-if="active==1">
				<div style="margin-top: 20px;width: 100%;">
					<el-form ref="form" :model="form" label-width="120px" :inline="true">
						<el-form-item label="计划名称">
							<el-select v-model="form.agreement_id" :disabled="task_type" placeholder="请选择"
								@change="getjihua">
								<el-option v-for="item in agreementArr" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="计划执行时间">
							<el-date-picker v-model="value1" style="width:500px" v-if="!task_type" type="daterange" @change="time"
								range-separator="至" start-placeholder="开始日期的" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" end-placeholder="结束日期的">
							</el-date-picker>
							<el-date-picker v-if="task_type" v-model="form.start_time" type="date" :disabled="task_type"
								placeholder="开始日期">
							</el-date-picker>
							<span v-if="task_type" style="margin: 0 10px;">至</span>
							<el-date-picker v-if="task_type" v-model="form.end_time" type="date" placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="销售所属区域">
							<!-- <el-select v-model="v" disabled placeholder="请选择" v-if="!task_type">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select> -->
							<el-input v-model="path_txt" disabled></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div>
					<div style="display: flex;">
						<div style="width: 120px;text-align: right;padding: 0 12px 0 0;">任务内容</div>
						<div style="padding: 20px;border: 1px dashed #f1f1f1;width: 88%;">
							<div style="display: flex;margin-bottom: 10px;">
								<div class="magin20" style="flex:0 0 18%">
									<div>任务类型</div>
								</div>
								<div class="magin20" style="flex:0 0 18%">
									<div>任务名称</div>
								</div>
								<div class="magin20" style="flex:0 0 21%">
									<div>关联产品</div>
								</div>
								<div class="magin20" style="margin-right: 0;">
									<div>关联资料(推广人使用资料次数，0表示不限制次数。一经提交不可修改)</div>
								</div>
								<!-- <div class="magin20" style="flex:0 0 3%">

								</div> -->
							</div>

							<div v-for="(item,index) in cont"
								style="display: flex;margin-bottom: 10px;">
								<div class="magin20" style="flex:0 0 18%">
									<el-select v-model="item.task_type" clearable :disabled="task_type"
										placeholder="请选择">
										<el-option v-for="item in options1" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
								<div class="magin20" style="flex:0 0 18%">
									<el-input v-model="item.task_name"></el-input>
								</div>
								<div class="magin20" style="flex:0 0 21%">
									<el-select v-model="item.link_products" style="width: 100%;" clearable
										placeholder="请选择" :disabled="link_products" @change="getproductsId">
										<el-option v-for="item in options2" :key="item.id" :label="item.title"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
								<div class="magin20" style="flex:0 0 33%">
									<!-- <el-select v-model="datas" multiple  style="width: 100%;"   placeholder="请选择"
										:disabled="isproductsDataDisabled"
										>
										<el-option v-for="item in options3" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select> -->

									<el-table ref="multipleApiTable" :row-style="{height:'35px'}"
    :cell-style="{padding:'0px'}" @selection-change="handleSelectionChange"
										:data="options3" max-height="500" border
										style="width: 100%" :header-cell-style="{
                        padding: '6px 0px',}"
>
										<el-table-column type="selection" :selectable="selected" width="40">
										</el-table-column>
										<el-table-column type="index" label="序号" width="50">
										</el-table-column>
										<el-table-column prop="name" label="资料名称" width="280">
										</el-table-column>
										<el-table-column prop="allow_use_times" label="使用次数" width="80">
											<template slot-scope="scope">
												<el-input  size="mini" style="border: 0;" :disabled="task_type" v-model="scope.row.allow_use_times"></el-input>
											</template>
										</el-table-column>
									</el-table>
								</div>
								<!-- 	<div class="magin20" style="flex:0 0 3%;cursor: pointer;" v-if="index>0"
									@click="del(index)">
									<i class="el-icon-remove-outline"></i>
								</div> -->
							</div>
							<!-- <div style="margin-top: 20px;" @click="add"><el-button
									icon="el-icon-plus">添加任务类型</el-button>
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<div v-if="active==2">
				<div>
					<el-select v-model="value" placeholder="请选择" style="width: 350px;" multiple @remove-tag="removeTag" v-default-select="[enterpriseIds]">
						<el-option v-for="item in options4"  :disabled="enterpriseIds.includes(item.promoter_id)" :key="item.promoter_id" :label="item.user_realname"
							:value="item.promoter_id">
						</el-option>
					</el-select>
					<el-button style="margin-left: 20px;" @click="addUser">添加推广人</el-button>
				</div>
				<div style="margin: 20px 0;padding-bottom: 100px;">
					<el-table :data="promoter_task_num" border style="width: 100%" :summary-method="getSummaries"
						show-summary>

						<el-table-column prop="name" label="推广人姓名" width="180">
							<template slot-scope="scope">
								<span>{{scope.row.name}}</span>(<span>{{scope.row.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}}</span>)
							</template>
						</el-table-column>
						<template v-for="(column, index) in col">
							<el-table-column :label="`${column.task_name}(个)`" :key="index" prop="num">
								<template slot-scope="scope">
									<el-input v-model="scope.row.num"
										@blur='numBlur(scope.$index,scope.row.num)'></el-input>
								</template>
							</el-table-column>

						</template>

						<el-table-column fixed="right" label="操作" width="100" v-if="task_type==false">
							<template slot-scope="scope">
								<el-button @click="deleteRow(scope.row)" type="text" size="small">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- <div>
						<div style="display: flex;">
							<div style="flex:0 0 15%;padding: 20px 0;">任务总次数</div>
							<div style="flex:0 0 10%;padding: 20px;">{{num}}</div>
							<div style="flex:0 0 30%;padding: 20px;">{{num1}}</div>
						</div>
					</div> -->
					<!-- <div>任务类型总次数：{{allnum}}；</div> -->
				</div>
			</div>
		</div>
		<div style="text-align: right;margin-top: 20px;">
			<el-button round @click="onCancel">取消</el-button>
			<el-button type="primary" v-if="active==1" round @click="next">下一步</el-button>
			<el-button type="primary" v-if="active==2" round @click="last">上一步</el-button>
			<el-button type="primary" v-if="active==2" round @click="save">保存</el-button>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				task_type: false,
				link_products: false,
				datasshow: false,
				num: 0,
				num1: 0,
				allnum: 0,
				value1: [],
				agreementArr: [],
				path_txt:'请指定计划名称',
				company_id: null,
				isproductsDataDisabled: true,
				enterpriseIds:[],
				companyData: [],
				options1: [],
				options3: [],
				promoter_task_num: [],
				options4: [],
				value: [],
				datas: [],
				cont: [{
					task_type: '',
					task_name: '',
					link_products: '',
					datas: [],

				}],
				col: [],
				options: [],
				options2: [],
				form: {
					id: ''
				},
				active: 1,
				v: null,
				id: '',
				promoter_task_num_list:[]
			};
		},
		created() {},
		async mounted() {
			this.getValidateList()
			this.getCompanyList()
			this.getsellArea()
			this.getgetType()
			// this.getproductList()
			
			if (this.$route.query.id) {
				this.task_type = true;
				this.link_products = true;
				this.id = this.$route.query.id;
				await this.getData({
					id: this.$route.query.id
				});
			}else{
				this.getUsername()
			}
		},
		methods: {
			handleSelectionChange(val) {
				this.datas = val;
			},
			selected(row, index) {
			  if (this.task_type) { 
			    return false
			  } else {
			    return true;
			  }
			},
			// 回显
			async getData(params) {
				let a = []
				let result = await this.$http.post('/task/info', params);
				if (result.data.status === 1) {
					let temp = result.data.data;
					this.form = temp.info;
					
					await this.getproductslist(temp.info.link_product)

					this.form.start_time = this.$moment.unix(temp.info.start_time).format("YYYY-MM-DD")
					this.form.end_time = this.$moment.unix(temp.info.end_time).format("YYYY-MM-DD")

					this.cont[0].task_name = temp.info.task_name
					this.cont[0].task_type = temp.info.task_type
					this.cont[0].link_products = temp.info.link_product_data.id
					this.options3.map((item)=>{
						temp.info.datas.map((data)=>{
							if(item.id==data.map_id){
								item.allow_use_times=data.allow_use_times
							}
						})
					})
					this.datas=temp.info.datas
					this.$nextTick(() => {
						this.datas.forEach(item => {
							this.$refs.multipleApiTable[0].toggleRowSelection(this.options3.find(tx => {
								return tx.id === item.map_id
							}), true)
						})
					})
					temp.promoter_list.map((item) => {
						let obj = {
							name: item.user_realname,
							id: item.promoter_id,
							mobile: item.mobile,
							num: item.assigned_num,
						}
						this.promoter_task_num.push(obj)
						this.value.push(item.promoter_id)
						this.enterpriseIds.push(item.promoter_id)
					})
					await this.getPromoterList()
				}
			},
			async getUsername(id, list) {
				let data = {
					task_id: id
				}
				let result = await this.$http.post('/promoter/getPromoterList');
				if (result.data.status === 1) {
					result.data.data.data_list.map((item)=>{
						item.num=0
					})
					this.options4 = result.data.data.data_list;
					
				}
			},
			// 获取计划
			async getValidateList() {
				let result = await this.$http.post('/agreement/getValidateList', {
					sign_mode: '1'
				});
				if (result.data.status === 1) {
					this.agreementArr = result.data.data.data_list;
					if(this.task_type){
						this.path_txt = result.data.data.data_list[0].path_txt;
					}
				}
			},
			// 获取合作企业
			async getCompanyList() {
				let result = await this.$http.post('/Company/getCooperationCompanyList');
				if (result.data.status === 1) {
					this.companyData = result.data.data.data_list;
					this.company_id = this.companyData[0].id
				}
			},
			// 获取销售所属区域
			async getsellArea() {
				let result = await this.$http.post('/task/sellArea');
				if (result.data.status === 1) {
					this.options = result.data.data.curr_list
					this.v = result.data.data.curr_list[0].id
				}
			},
			// 获取销售所属区域
			async getPromoterList(id) {
				let result = await this.$http.post('/promoter/getPromoterList');
				if (result.data.status === 1) {
					this.options4 = result.data.data.data_list
					this.options4.map((item)=>{
						this.promoter_task_num.map((data)=>{
							if(item.promoter_id==data.id){
								item.num=data.num
							}else{
								item.num=0
							}
						})
					})
					
				}
			},
			async getgetType() {
				let result = await this.$http.post('/task/getType');
				if (result.data.status === 1) {
					this.options1 = result.data.data
				}
			},
			async getproductList(val) {
				let result = await this.$http.post('/product/getList', {
					cooperation_company_id: this.company_id
				});
				if (result.data.status === 1) {
					this.options2 = result.data.data.data_list
					this.path_txt = this.agreementArr[0].path_txt;
				}
			},
			async getjihua(val) {
				this.value1=[]
				this.agreementArr.map((item)=>{
					if(val==item.id){
						this.path_txt=item.path_txt
						this.value1.push(this.$moment.unix(item.service_start_time).format("YYYY-MM-DD"))
						this.value1.push(this.$moment.unix(item.service_end_time).format("YYYY-MM-DD"))
						this.form.start_time = this.$moment.unix(item.service_start_time).format("YYYY-MM-DD")
						this.form.end_time = this.$moment.unix(item.service_end_time).format("YYYY-MM-DD")
					}
				})
				this.getproductList()
			},
			async getproductsId(val) {
				this.isproductsDataDisabled = false
				this.getproductslist(val)
			},
			async getproductslist(val) {
				let data = {
					product_id: val,
					agreement_id: this.form.agreement_id,
					scene: '2'
				}
				let result = await this.$http.post('/product/relations', data);
				if (result.data.status === 1) {
					result.data.data.map((item) => {
						item.allow_use_times = 0
					})
					this.options3 = result.data.data
				}
			},
			numBlur(index, number) {
				// let total = 0;
				// let total1 = 0;
				// this.promoter_task_num.map((item) => {
				// 	total += parseInt(item.num)
				// 	this.num = total
				// 	// total1 += parseInt(item.num1)
				// 	// this.num1 = total1
				// 	this.allnum = total 
				// })
				this.promoter_task_num[index].num = number
				if (index === (this.promoter_task_num.length - 1)) {
					this.promoter_task_num = this.promoter_task_num
				}
			},
			getSummaries(param) {
				const {
					columns,
					data
				} = param
				const sums = []
				columns.forEach((column, index) => {
					// 设置第一列的值为总计
					if (index === 0) {
						sums[index] = '总计'
						return
					}
					const values = data.map(item => {
						return Number(item[column.property])
					});
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] += ' 次';
					} else {
						sums[index] = '';
					}
				})
				return sums
			},
			selectChange(val) {
				console.log(val)
				// this.cont[0].datas=JSON.parse(JSON.stringify(this.datas))
				// this.cont[0].datas.map((item)=>{
				// 	delete  item.name
				// })
			},
			onChangecompany(value) {
				this.company_id = value;
			},
			async save() {
				this.form.task_list = this.cont
				
				this.datas.map((item) => {
					this.form.task_list[0].datas.push({
						map_id: item.id,
						allow_use_times:item.allow_use_times
					})
				})
				this.form.id = this.id
				this.form.cooperation_company_id = this.company_id
				this.form.promoter_task_num = this.promoter_task_num
				let result = await this.$http.post('/task/update', this.form);
				if (result.data.status === 1) {
					this.$message.success('操作成功！');
					this.$router.back();
				}else{
					this.form.task_list[0].datas=[]
				}
			},
			deleteRow(index, rows) {
				this.promoter_task_num.splice(index, 1)
				this.value.splice(index, 1)
				// let total = 0;
				// if (this.promoter_task_num.length > 0) {
				// 	this.promoter_task_num.map((item) => {
				// 		total += parseInt(item.num)
				// 		this.num = total
				// 		this.allnum = total
				// 	})
				// } else {
				// 	this.allnum = total
				// }

			},
			next() {
				this.active = 2
				this.col = JSON.parse(JSON.stringify(this.cont))
				// this.col.map((item) => {
				// 	item.key = 'num'
				// })
			},
			last() {
				this.active = 1
				this.$nextTick(() => {
					this.datas.forEach(item => {
						this.$refs.multipleApiTable[0].toggleRowSelection(this.options3.find(tx => {
							return tx.id === item.id
						}), true)
					})
				})

			},
			addUser() {
				this.promoter_task_num = []
				this.value.map((item) => {
					this.options4.map((data) => {
						if (item == data.promoters.id) {
							console.log(data)
							this.promoter_task_num.push({
								name: data.user_realname,
								id: data.promoters.id,
								mobile: data.promoters.mobile,
								num:data.num
							})

						}
					})
				})
			},

			add() {
				this.cont.push({
					task_type: '',
					task_name: '',
					link_products: '',
					datas: '',
				})
			},
			time(val) {
				console.log(val)
				this.form.start_time = val[0]
				this.form.end_time = val[1]
			},
			async removeTag(id) {
				this.promoter_task_num.splice(this.promoter_task_num.findIndex(item => item.id === id), 1)
			},
			del(i) {
				this.cont.splice(i, 1)
			},
			// 取消
			onCancel() {
				this.$router.back();
			},
		},
	};
</script>
<style scoped lang="scss">
	.magin20 {
		margin-right: 20px;
	}
	 
</style>
